import { useEffect, useState } from "react";
import { ExternalLink, Factory } from "lucide-react";
import { api } from "../../lib/api";

export default function SuppliersPage() {
  const [suppliers, setSuppliers] = useState([]);

  useEffect(() => {
    api.get("/admin/suppliers").then((r) => setSuppliers(r.data.suppliers));
  }, []);

  return (
    <div data-testid="admin-suppliers-page">
      <div className="mb-6">
        <p className="eyebrow">Sourcing</p>
        <h1 className="font-heading text-2xl font-bold text-white">Manufacturer directory</h1>
        <p className="mt-1 text-xs text-slate-500">Orders route straight to these AliExpress / Alibaba suppliers — no middleman markup.</p>
      </div>
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {suppliers.map((s) => (
          <div key={s.id} className="card-surface p-6" data-testid={`supplier-card-${s.id}`}>
            <div className="flex items-start justify-between">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-amber-400/10 text-amber-300">
                <Factory size={20} />
              </span>
              <span className={`rounded-full px-3 py-1 text-[11px] font-bold uppercase tracking-wider ${
                s.platform === "alibaba" ? "bg-orange-400/15 text-orange-300" : "bg-rose-400/15 text-rose-300"
              }`}>
                {s.platform}
              </span>
            </div>
            <p className="mt-4 font-heading font-semibold text-white">{s.name}</p>
            <p className="mt-1 text-xs text-slate-500">{s.location}</p>
            <div className="mt-4 grid grid-cols-3 gap-2 text-center text-xs">
              <div className="rounded-lg bg-white/[0.04] py-2"><p className="font-semibold text-white">{s.rating}★</p><p className="text-slate-600">Rating</p></div>
              <div className="rounded-lg bg-white/[0.04] py-2"><p className="font-semibold text-white">{s.on_time_rate}%</p><p className="text-slate-600">On-time</p></div>
              <div className="rounded-lg bg-white/[0.04] py-2"><p className="font-semibold text-white">{s.product_count}</p><p className="text-slate-600">Products</p></div>
            </div>
            <a
              href={s.url}
              target="_blank"
              rel="noreferrer"
              data-testid={`supplier-visit-${s.id}`}
              className="btn-ghost mt-4 w-full !py-2 text-xs"
            >
              Visit supplier <ExternalLink size={12} />
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}
